// src/pages/CookiePolicy.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function CookiePolicy() {
  return (
    <div className="min-h-screen bg-[#0f0f0f] text-white flex flex-col">

      {/* NAV */}
      <div className="flex justify-between items-center px-6 py-4 border-b border-white/10">
        <Link to="/">
          <img
            src="https://cdn.prod.website-files.com/638fda8f8e2f041af84cb5a7/6824d581ae24f69d45e26536_beem%20logo%203.png"
            alt="Beem Logo"
            className="w-28"
            style={{ cursor: "pointer" }}
          />
        </Link>
      </div>

      {/* CONTENT */}
      <div className="flex justify-center px-6 py-12">
        <div className="max-w-3xl w-full">

          <h1 className="text-4xl font-bold mb-4">Cookie Policy</h1>
          <p className="text-gray-400 mb-8">
            Effective date: 09/06/2026
          </p>

          <div className="space-y-8 text-gray-300 text-sm leading-relaxed">

            {/* INTRO */}
            <section>
              <p>
                This Cookie Policy explains how Beem Tech Limited ("Beem", "we", "us", or "our") uses cookies
                and similar technologies when you use the Beem platform, website, and related services.
              </p>
            </section>

            {/* WHAT ARE COOKIES */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">1. What Are Cookies</h2>
              <p>
                Cookies are small text files stored on your device when you visit a website. They help websites
                function properly and provide information about how users interact with them.
              </p>
            </section>

            {/* HOW WE USE COOKIES */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">2. How We Use Cookies</h2>
              <p>We use cookies to:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Keep users signed in</li>
                <li>Improve platform performance and functionality</li>
                <li>Understand how users interact with Beem</li>
                <li>Enhance security and prevent fraud</li>
                <li>Remember user preferences</li>
              </ul>
            </section>

            {/* TYPES OF COOKIES */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">3. Types of Cookies We Use</h2>

              <h3 className="text-white font-semibold mt-2">Essential Cookies</h3>
              <p>
                These cookies are required for the platform to function properly, such as authentication and
                session management.
              </p>

              <h3 className="text-white font-semibold mt-4">Analytics Cookies</h3>
              <p>
                These help us understand how users interact with Beem so we can improve the product.
              </p>

              <h3 className="text-white font-semibold mt-4">Functional Cookies</h3>
              <p>
                These remember your preferences and settings to improve your experience.
              </p>
            </section>

            {/* THIRD PARTY */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">4. Third-Party Cookies</h2>
              <p>
                Some third-party services we use, such as Stripe for payments or analytics providers,
                may also set cookies on your device.
              </p>
              <p className="mt-2">
                These third parties have their own privacy and cookie policies.
              </p>
            </section>

            {/* COOKIE CONTROL */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">5. Managing Cookies</h2>
              <p>
                You can control or disable cookies through your browser settings.
              </p>
              <p className="mt-2">
                Please note that disabling cookies may affect the functionality of the Beem platform.
              </p>
            </section>

            {/* CHANGES */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">6. Changes to This Policy</h2>
              <p>
                We may update this Cookie Policy from time to time to reflect changes in technology or legal requirements.
              </p>
            </section>

            {/* CONTACT */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">7. Contact</h2>
              <p>
                If you have any questions about this Cookie Policy, contact us at:
                <br />
                📧 wjelson@beemtech.co.uk
              </p>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
}
